export default __webpack_public_path__ + "static/media/wi-fi Strong Signal.696916e5.svg";